<script setup>
import { storeToRefs } from 'pinia';
import { RouterView } from 'vue-router';
import AccountNavComponent from '../components/AccountNavComponent.vue';
import { useAuthStore } from '../../../auth/stores/auth-store';

/**
 * User store
 */
const { authUser, loading, submitting, error } = storeToRefs(useAuthStore());
</script>

<template>
  <div class="container">
    <div class="row my-3 align-items-center" v-if="authUser">
      <div class="col-auto">
        <img
          src="../../../app/assets/logo.png"
          class="rounded-circle"
          alt="Profile"
        />
      </div>
      <div class="col">
        <div>
          <span class="fs-2" v-if="authUser">{{ authUser.displayName }}</span>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-lg-3">
        <AccountNavComponent />
      </div>
      <div class="col-lg-9 mt-3 mt-lg-0">
        <div class="card mb-3">
          <div class="card-body">
            <RouterView />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
